import '@babel/polyfill'
import 'innersvg-polyfill'
import _ from 'lodash'
import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import store from './store'
import * as types from './store/types'
import scroll from './support/scroll'
import HeadMixin from './mixins/head'

store.commit(types.preload.mutations.got, window.preload)

/**
 * Require
 */
require('./support/mixins')
require('./support/directives')
require('./support/filters')
require('./support/preload')

/**
 * Http
 */
const apiToken = _.preload('user.data.api_token')
const personaToken = _.preload('persona_token')

axios.defaults.headers.common = _.extend(
    apiToken ? { Authorization: `Bearer ${apiToken}` } : {},
    personaToken ? { 'X-PERSONA-TOKEN': personaToken } : {},
    {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': _.preload('csrf_token')
    }
)

/**
 * Use
 */
if (!_.preload('app.debug')) {
    Vue.use(require('../../node_modules/@honeybadger-io/vue/src/index').default, {
        apiKey: _.preload('keys.honeybadger'),
        environment: _.preload('app.env'),
        revision: process.env.REVISION
    })
}
Vue.use(VueRouter)
if (_.preload('keys.google-tag-manager')) {
    Vue.use(require('vue-gtm').default, {
        id: _.preload('keys.google-tag-manager'),
        enabled: true,
        debug: false
    })
}
Vue.use(require('vue-meta').default)
Vue.use(require('vue-moment'))
Vue.use(require('portal-vue').default)
Vue.use(require('vue-instantsearch').default)
Vue.use(require('vue-clipboard2'))
Vue.use(require('./plugins/echo/echo').default, {
    key: _.preload('keys.pusher'),
    csrf_token: _.preload('csrf_token'),
    headers: {
        ...(personaToken ? { 'X-PERSONA-TOKEN': personaToken } : {})
    }
})
Vue.use(require('./plugins/error/error').default)
Vue.use(require('./plugins/event-bus/event-bus').default)
Vue.use(require('./plugins/gate/plugin').default)
Vue.use(require('./plugins/introjs/introjs').default)
Vue.use(require('./plugins/laroute/laroute').default)
Vue.use(require('./plugins/lodash/lodash').default)
Vue.use(require('./plugins/screen/plugin').default)
Vue.use(require('./plugins/stripe/stripe').default, {
    key: _.preload('keys.stripe')
})
Vue.use(require('./plugins/track/plugin').default)
Vue.use(require('./plugins/validator/validator').default)

/**
 * Components
 */
Vue.component('a-mailto', require('./components/a-mailto').default)
Vue.component('a-tel', require('./components/a-tel').default)
Vue.component('algolia-get', require('./components/algolia-get').default)
Vue.component('algolia-places-get', require('./components/algolia-places-get').default)
Vue.component('base-abbr', require('./components/base-abbr').default)
Vue.component('base-address', require('./components/base-address').default)
Vue.component('base-alert', require('./components/base-alert').default)
Vue.component('base-button', require('./components/base-button').default)
Vue.component('base-dropdown', require('./components/base-dropdown').default)
Vue.component('base-expandable', require('./components/base-expandable').default)
Vue.component('base-form', require('./components/base-form').default)
Vue.component('base-form-footer', require('./components/base-form-footer').default)
Vue.component('base-hint', require('./components/base-hint').default)
Vue.component('base-loading', require('./components/base-loading').default)
Vue.component('base-more', require('./components/base-more').default)
Vue.component('base-na', require('./components/base-na').default)
Vue.component('base-pagination', require('./components/base-pagination').default)
Vue.component('base-period', require('./components/base-period').default)
Vue.component('base-svg', require('./components/base-svg').default)
Vue.component('base-tooltip', require('./components/base-tooltip').default)
Vue.component('error-modal', require('./components/error-modal').default)
Vue.component('expandable-text', require('./components/expandable-text').default)
Vue.component('file-modal', require('./components/file-modal').default)
Vue.component('form-item', require('./components/form-item').default)
Vue.component('form-section', require('./components/form-section').default)
Vue.component('grid-layout', require('./components/grid-layout').default)
Vue.component('grid-layout-item', require('./components/grid-layout-item').default)
Vue.component('image-carousel', require('./components/image-carousel').default)
Vue.component('img-aspect-ratio', require('./components/img-aspect-ratio').default)
Vue.component('input-checkbox', require('./components/input-checkbox').default)
Vue.component('input-clipboard', require('./components/input-clipboard').default)
Vue.component('input-date', require('./components/input-date').default)
Vue.component('input-radio', require('./components/input-radio').default)
Vue.component('input-select', require('./components/input-select').default)
Vue.component('input-telephone', require('./components/input-telephone').default)
Vue.component('input-text', require('./components/input-text').default)
Vue.component('input-textarea', require('./components/input-textarea').default)
Vue.component('input-upload', require('./components/input-upload').default)
Vue.component('input-uploads', require('./components/input-uploads').default)
Vue.component('modal-blue', require('./components/modal-blue').default)
Vue.component('modal-error', require('./components/modal-error').default)
Vue.component('modal-red', require('./components/modal-red').default)
Vue.component('modal-success', require('./components/modal-success').default)
Vue.component('on-click-outside', require('./components/on-click-outside').default)
Vue.component('on-escape', require('./components/on-escape').default)
Vue.component('recaptcha-form', require('./components/recaptcha-form').default)
Vue.component('table-ish', require('./components/table-ish').default)
Vue.component('table-ish-cell', require('./components/table-ish-cell').default)
Vue.component('table-ish-cell-router-link', require('./components/table-ish-cell-router-link').default)
Vue.component('table-ish-row', require('./components/table-ish-row').default)
Vue.component('table-ish-row-header', require('./components/table-ish-row-header').default)
Vue.component('table-ish-row-router-link', require('./components/table-ish-row-router-link').default)
Vue.component('the-slidenav', require('./components/the-slidenav').default)
Vue.component('truncate-hack', require('./components/truncate-hack').default)
Vue.component('validator-alert', require('./components/validator-alert').default)
Vue.component('with-callback', require('./components/with-callback').default)
Vue.component('with-dimensions', require('./components/with-dimensions').default)
Vue.component('with-scrolling', require('./components/with-scrolling').default)
Vue.component('with-truthiness', require('./components/with-truthiness').default)
Vue.component('with-variables', require('./components/with-variables').default)

/**
 * Router
 */
const router = new VueRouter({
    routes: [
        ...require('./routes/applications').default,
        ...require('./routes/auth').default,
        ...require('./routes/dashboard').default,
        ...require('./routes/invitations').default,
        ...require('./routes/job-sheets').default,
        ...require('./routes/residencies').default,
        ...require('./routes/www').default
    ],
    mode: 'history',
    scrollBehavior () {
        return {
            x: 0,
            y: 0
        }
    }
})

// $router.fix('dashboard.*.overview.index') // fixes the *
router.fix = name => {
    const matched = router.currentRoute.matched.slice().reverse().find(route => route.name)

    if (!(matched && matched.name)) {
        return name
    }

    const split = _.split(matched.name, '.')

    return _.chain(name)
        .split('.')
        .map((segment, index) => segment === '*' ? split[index] : segment)
        .join('.')
        .value()
}

router.beforeEach((to, from, next) => {
    Vue.prototype.$validator.reset()

    scroll.toTop()

    return next()
})

/**
 * App
 */
export default new Vue({
    mixins: [
        HeadMixin
    ],
    i18n: require('./support/i18n').default,
    store,
    router,
    render: h => h(require('./components/the-app').default)
}).$mount('#app')
